/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Iframe_TitleInputs */

const en_vc_onl_iframe_title = /** @type {(inputs: Vc_Onl_Iframe_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft vector illustration app`)
};

const zh_vc_onl_iframe_title = /** @type {(inputs: Vc_Onl_Iframe_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 矢量插画应用`)
};

/**
* | output |
* | --- |
* | "VectorCraft vector illustration app" |
*
* @param {Vc_Onl_Iframe_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_iframe_title = /** @type {((inputs?: Vc_Onl_Iframe_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Iframe_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_iframe_title(inputs)
	return zh_vc_onl_iframe_title(inputs)
});
export { vc_onl_iframe_title as "vc.onl.iframe_title" }